import { Component, OnInit, Input } from '@angular/core';
import { IWizardContentComponent } from '../../../wizard.content';

@Component({
  selector: 'user-results',
  templateUrl: './user-results.component.html',
  styleUrls: ['./user-results.component.scss']
})
export class UserResultsComponent implements IWizardContentComponent  {

  @Input() step: any;
  @Input() subStep: any;
  @Input() wizardCtrl: any;
  @Input() id: string;
  @Input() previousOutput: any;

  constructor() {
  }

  requestFailed() {
    return this.wizardCtrl.getWizardService().requestFailed;
  }

  get errorMessage() {
    return this.wizardCtrl.getWizardService().errorMessage;
  }

  get errorDescription() {
    return this.wizardCtrl.getWizardService().errorDescription;
  }

  get successMessage() {
    return this.wizardCtrl.getWizardService().successMessage;
  }

}
